/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Input,
  message,
  Modal,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import {
  CopyOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import React, { useEffect, useState } from "react";

import { ModalDelete } from "./componentes/modalDelete";
import { ModalDetalhes } from "./componentes/modalDetalhes";
import CadastroAcessoRemoto from "./componentes/modalInserir";

import CartorioRequest from "../../CartorioRequest";

import { ufs } from "../../../../Constante/UFS";
import { colors } from "../../../../Utils/temas";

import { SiAuth0 } from "react-icons/si";
import { IoKeyOutline } from "react-icons/io5";
import { useUserContext } from "../../../../contexts/usersContext";

export const AcessoRemotoTab = ({ id, tab }) => {
  const { currentUser } = useUserContext();

  const [acessoRemoto, setAcessoRemoto] = useState([]);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openInsert, setOpenInsert] = useState(false);
  const [openToken, setOpenToken] = useState(false);
  const [loadingToken, setLoadingToken] = useState(false);
  const [tokenValue, setTokenValue] = useState("");
  const [tokenTimeLeft, setTokenTimeLeft] = useState("");
  const [openSecretModal, setOpenSecretModal] = useState(false);
  const [loadingSecret, setLoadingSecret] = useState(false);
  const [secretValue, setSecretValue] = useState("");
  const [secretId, setSecretId] = useState(null);

  const [idAcesso, setIdAcesso] = useState(null);

  const [totalRecords, setTotalRecords] = useState(null);

  useEffect(() => {
    if (tab === 1) {
      getAcessoRemoto(1, 10, filtro);
    }
  }, [tab]);

  const filtro = { cartorio_id: id };

  const header = [
    {
      key: "nome_cartorio",
      dataIndex: "nome_cartorio",
      title: "Nome cartório",
    },
    {
      title: "Tipo conexão",
      dataIndex: "tipo_conexao",
    },
    { key: "conexao_obs", dataIndex: "conexao_obs", title: "Observação" },
    {
      key: "acoes",
      title: "Ações",
      render: (values) => (
        <Space>
          <Tooltip title="Visualizar token">
            <SiAuth0
              style={{ fontSize: 14, cursor: "pointer", marginTop: 5 }}
              onClick={() => handleOpenToken(values.id)}
            />
          </Tooltip>

          {currentUser.is_staff ||
          currentUser.is_superuser ||
          currentUser.is_manager ? (
            <Tooltip title="Atualizar secret">
              <IoKeyOutline
                style={{ fontSize: 14, cursor: "pointer", marginTop: 5 }}
                onClick={() => handleOpenSecretModal(values.id)}
              />
            </Tooltip>
          ) : null}

          <Tooltip title="Detalhes">
            <CopyOutlined onClick={() => handleOpenDetails(values.id)} />
          </Tooltip>

          <Tooltip title="Editar">
            <EditOutlined onClick={() => handleOpenEdit(values.id)} />
          </Tooltip>

          <Tooltip title="Excluir">
            <DeleteOutlined onClick={() => handleOpenDelete(values.id)} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const getAcessoRemoto = async (page, pageSize, params) => {
    setLoading(true);
    try {
      const response = await CartorioRequest.getListaAcessoRemoto(
        page,
        pageSize,
        params,
      );
      if (response.status === 200 || response.status === 201) {
        const { results, count } = response.data;
        setAcessoRemoto(results);
        setTotalRecords(count);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDetails = (valueId) => {
    setOpen(true);
    setIdAcesso(valueId);
  };

  const handleOpenEdit = (valueId) => {
    setOpenInsert(true);
    setIdAcesso(valueId);
  };

  const handleOpenDelete = (valueId) => {
    setOpenDelete(true);
    setIdAcesso(valueId);
  };

  const handleOpenSecretModal = (valueId) => {
    setSecretId(valueId);
    setSecretValue("");
    setOpenSecretModal(true);
  };

  const handleUpdateSecret = async () => {
    if (!secretValue || !secretValue.trim()) {
      message.warning("Informe o secret para atualizar.");
      return;
    }

    setLoadingSecret(true);
    try {
      const response = await CartorioRequest.atualizarSecretAcessoRemoto(
        secretId,
        secretValue.trim(),
      );

      if (response.status === 204) {
        message.success("Secret atualizado com sucesso.");
        setOpenSecretModal(false);
        setSecretValue("");
        setSecretId(null);
        getAcessoRemoto(1, 10, filtro);
      }
    } catch (error) {
      console.error(error);
      message.error("Nao foi possivel atualizar o secret.");
    } finally {
      setLoadingSecret(false);
    }
  };

  const handleOpenToken = async (valueId) => {
    setOpenToken(true);
    setLoadingToken(true);
    setTokenValue("");
    setTokenTimeLeft("");
    try {
      const response = await CartorioRequest.getAcessoRemoto(valueId);
      if (response.status === 200 || response.status === 201) {
        const token = response?.data?.token || "";
        const [code = "", timeLeft = ""] = String(token).split("|");
        setTokenValue(code);
        setTokenTimeLeft(timeLeft);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingToken(false);
    }
  };

  const optionsUf = ufs.map((uf) => {
    return {
      label: uf.sigla,
      value: uf.sigla,
    };
  });

  return (
    <>
      <Table
        dataSource={acessoRemoto}
        columns={header}
        title={() => (
          <Space>
            <Button
              style={{
                background: colors.secondary,
                color: "white",
                fontWeight: "500",
              }}
              onClick={() => setOpenInsert(true)}
              icon={<PlusOutlined />}
              className="botao"
            >
              Inserir
            </Button>
          </Space>
        )}
        loading={loading}
        pagination={{
          total: totalRecords,
          showTotal: (total) => (
            <span
              style={{ fontWeight: "500", position: "absolute", left: "4%" }}
            >
              Quantidade: {total}
            </span>
          ),
          onChange: (page, pageSize) => getAcessoRemoto(page, pageSize, filtro),
        }}
      />
      <ModalDetalhes
        id={idAcesso}
        onCancel={() => {
          setOpen(false);
          setIdAcesso(null);
        }}
        visible={open}
      />
      <ModalDelete
        onCancel={() => {
          setOpenDelete(false);
          setIdAcesso(null);
        }}
        id={idAcesso}
        visible={openDelete}
        estadoAcessoRemoto={setAcessoRemoto}
      />
      <CadastroAcessoRemoto
        estadoAcesso={() => getAcessoRemoto(1, 10, filtro)}
        onCancel={() => {
          setOpenInsert(false);
          setIdAcesso(null);
        }}
        visible={openInsert}
        optionsUf={optionsUf}
        id={id}
        idAcessoRemoto={idAcesso}
      />
      <Modal
        title="Atualizar secret"
        visible={openSecretModal}
        onOk={handleUpdateSecret}
        confirmLoading={loadingSecret}
        onCancel={() => {
          setOpenSecretModal(false);
          setSecretValue("");
          setSecretId(null);
        }}
      >
        <Input
          value={secretValue}
          onChange={(event) => setSecretValue(event.target.value)}
          placeholder="Informe o novo secret"
        />
      </Modal>

      <Modal
        title="Token de acesso remoto"
        visible={openToken}
        footer={null}
        onCancel={() => {
          setOpenToken(false);
          setTokenValue("");
          setTokenTimeLeft("");
        }}
      >
        {loadingToken ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Input value={tokenValue} readOnly />
            <div
              style={{
                marginTop: 8,
                color: "red",
                fontWeight: 500,
              }}
            >
              {tokenTimeLeft || "-"}
            </div>
          </>
        )}
      </Modal>
    </>
  );
};
